import { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Header from './header';
import Nav from './nav';
import CompanySystemTitle from '../../components/company-system-title/CompanySystemTitle';

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: 64 + 24, // MOBILE HEADER + padding
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: 92 + 24, // DESKTOP HEADER + padding
    // 不再預留左側空間
    paddingLeft: 0,
    paddingRight: 0,
  },
}));

export default function DashboardLayout() {
  const [openNav, setOpenNav] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const jwtData = sessionStorage.getItem('jwtData');
    const userSN = sessionStorage.getItem('userSN');

    const clearSessionAndRedirect = () => {
      sessionStorage.clear();
      navigate('/login', { replace: true });
    };

    if (!jwtData || !userSN || userSN.trim() === '') {
      clearSessionAndRedirect();
      return;
    }

    try {
      const parsedToken = JSON.parse(jwtData);
      const expiresAt = parsedToken.exp ? parsedToken.exp * 1000 : null;

      if (expiresAt && Date.now() >= expiresAt) {
        clearSessionAndRedirect();
      }
    } catch (error) {
      clearSessionAndRedirect();
    }
  }, [navigate]);

  return (
    <StyledRoot>
      <CompanySystemTitle />
      <Header onOpenNav={() => setOpenNav(true)} />
      <Nav openNav={openNav} onCloseNav={() => setOpenNav(false)} />
      <Main>
        <Outlet />
      </Main>
    </StyledRoot>
  );
}
